import React, { useState } from 'react'
import useFetch from '../../../../hooks/useAxios'
import Button from '../../../shared/Button'
import AdminFastsearchCon from './AdminFastsearchCon'
import AdminFastSearchForm from './AdminFastSearchForm'

const AdminFastSearch = ({}) => {
  const [searchlist, setsearchlist] = useState([])
  const apiGetHomeInfo = useFetch({
    method: "get",
    url: "api/admin/fast-searches",
    noHeader: false,
    trigger: true,
    argFunc:(res)=>{
      setsearchlist(res.data)
    }
    
  });
  return (
    <div className='AdminFastSearch'>
       <div className='flex ResidenceHeader  justify-between items-center'>
        <h4 className='ResidenceHeader--h4'>جست و جوی سریع</h4>
       
        </div>
        <AdminFastSearchForm apiget={apiGetHomeInfo}/>
        <AdminFastsearchCon   searchlist={searchlist}/>
    
    </div>
  )
}

export default AdminFastSearch